class ConstEstadoPedido
{
  SINCOFIRMAR = 1;
  PROCESOERNTREGA = 2;
  ENTREGADO  = 3;
  CONFIRMADO = 4;
  DEVUELTO_VALIDACION = 5;
  DECLINADO = 6;
  FINALIZADO = 8;

  get(id){
    switch (id){
      case this.SINCOFIRMAR: return "unconfirmed";
      case this.PROCESOERNTREGA: return "in_delivery";
      case this.ENTREGADO: return "delivered";
      case this.CONFIRMADO: return "confirmed";
      case this.DEVUELTO_VALIDACION: return "returned_validation";
      case this.DECLINADO: return "declined";
      case this.FINALIZADO: return "finalized";
    }
  }

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = ConstEstadoPedido;
